<app-breadcrumb></app-breadcrumb>
<div class="container">
  <div class="main-container-version">
    <!-- Coming Soon Section -->
    <div class="section">
      <div class="flex w-full justify-content-between p-2">
        <div class="category">coming soon</div>
        <button class="mark-read-btn" (click)="onMarkAllRead('features')" [disabled]="featuresReadDisabled">
          Mark All Read
        </button>
      </div>
      <div class="accordion-container">
        <p-accordion value="0">
          @for (feature of futureFeatures; track $index; let last = $last) {
            @if(feature.visible) {
              <p-accordionTab (click)="onGroupItemSelected(feature, 'feature')">
                <ng-template pTemplate="header">
                  <span class="accordion-header">
                    <span>{{feature.name}}</span>
                    @if(feature.isNew) {
                    <p-badge value="New!" severity="warning" class="ml-auto mr-2"></p-badge>
                    }
                  </span>
                </ng-template>
                <p class="version-description-text m-0">
                  {{feature.description}}
                </p>
              </p-accordionTab>
              <div class="h-divider" *ngIf="!last"></div>
            }
          }
        </p-accordion>
      </div>
      <!-- Known Issues -->
      <div class="flex w-full justify-content-between p-2">
        <div class="category">known issues</div>
        <button class="mark-read-btn" (click)="onMarkAllRead('issues')" [disabled]="issuesReadDisabled">
          Mark All Read
        </button>
      </div>
      <div class="accordion-container">
        <p-accordion value="0">
          @for (issue of knownIssues; track $index; let last = $last) {
          <p-accordionTab (click)="onGroupItemSelected(issue, 'issue')">
            <ng-template pTemplate="header">
              <span class="accordion-header">
                <span>{{issue.name}}</span>
                @if(issue.isNew) {
                <p-badge value="New!" severity="warning" class="ml-auto mr-2"></p-badge>
                }
              </span>
            </ng-template>
            <p class="version-description-text m-0">
              {{issue.description}}
            </p>
          </p-accordionTab>
          <div class="h-divider" *ngIf="!last"></div>
          }
        </p-accordion>
      </div>
      <!-- Version History -->
      <div class="flex w-full justify-content-between p-2">
        <div class="category">versions</div>
        <button class="mark-read-btn" (click)="onMarkAllRead('versions')" [disabled]="versionsReadDisabled">
          Mark All Read
        </button>
      </div>
      <div class="accordion-container">
        <p-accordion value="0">
          @for (version of versionData; track $index; let last = $last) {
          <p-accordionTab (click)="onGroupItemSelected(version, 'version')">
            <ng-template pTemplate="header">
              <span class="accordion-header">
                <div class="w-6rem">
                  <div class="flex justify-content-between">
                    <span>{{version.version}}</span>
                    @if (version.beta) {
                    <p-badge value="Beta" severity="success"></p-badge>
                    }
                  </div>
  
                </div>
                @if (version.isNew) {
                <p-badge value="New!" severity="warning" class="ml-auto mr-2"></p-badge>
                }
              </span>
            </ng-template>
            <div class="release-row">
              <div class="description-label">Release Date:</div>
              <div class="release-date">
                {{ version.releaseDate }}
              </div>
            </div>
            <div class="description-row">
              <div class="description-label">Description:</div>
              <div class="version-description-text">
                {{ version.description }}
              </div>
            </div>
            <div class="list-column">
              <div class="description-label">Features:</div>
              <ul>
                @for (feature of version.features; track $index) {
                <li class="accordion-item-content-text">
                  {{ feature }}
                </li>
                }
              </ul>
            </div>
            <div class="list-column">
              <div class="description-label">Fixes:</div>
              <ul>
                @for (fix of version.fixes; track $index) {
                <li class="accordion-item-content-text">
                  {{ fix }}
                </li>
                }
              </ul>
            </div>
          </p-accordionTab>
          <div class="h-divider" *ngIf="!last"></div>
          }
        </p-accordion>
      </div>
    </div>
  </div>
</div>